import React from "react";
import "./index.css";

const Dataloader = (props) => {
  return (
    <div className="data-loader">
      <p>{props.loaderText}</p>
    </div>
  );
};

export default Dataloader;



// WEBPACK FOOTER //
// ./src/new/Components/Data-loader/index.jsx